var _ellipse, _path, _circle, _path2, _ellipse2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path5, _path6, _path7, _path8, _path9, _path10, _circle2, _circle3, _circle4, _circle5, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 704,
    height: 506,
    viewBox: "0 0 704 506",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 278.779,
    cy: 180.451,
    rx: 183.081,
    ry: 180.451,
    fill: "#FFBA07"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M608.115 360.902C539.977 360.902 521.2 360.902 413.985 360.902C306.771 360.902 322.706 360.902 219.856 360.902C219.856 310.927 306.771 270.414 413.985 270.414C521.2 270.414 608.115 310.927 608.115 360.902Z",
    fill: "#2D2D2D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 266.153,
    cy: 153.62,
    r: 10.5219,
    fill: "#09DE1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M290.453 294.169C294.024 289.743 309.82 284.401 317.272 282.282C283.393 251.454 282.565 177.344 286.385 144.143C303.946 148.449 317.49 198.11 322.067 222.403C329.465 186.267 314.977 150.285 306.808 136.811C318.353 125.201 347.401 130.328 360.481 134.343C289.493 88.6019 287.046 117.479 282.045 111.317C278.044 106.387 285.441 96.2457 289.64 91.7912C280.6 92.2069 273.146 102.493 270.55 107.584C267.028 96.6662 249.166 94.0075 240.674 94.0428C248.286 95.3974 255.104 106.874 257.562 112.442C198.804 115.144 191.003 142.492 194.447 155.828C199.496 134.289 239.214 130.687 258.442 131.578C222.625 157.089 235.551 201.523 246.492 220.551C247.109 184.727 263.993 156.536 272.358 146.918C263.112 192.088 285.989 299.701 290.453 294.169Z",
    fill: "#2D2D2D",
    stroke: "#2D2D2D"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 288.249,
    cy: 147.833,
    rx: 10.5219,
    ry: 11.048,
    fill: "#09DE1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M475.694 191.563C477.299 189.265 480.278 188.462 482.853 189.568L637.166 255.878C640.211 257.186 641.618 260.715 640.31 263.759L614.593 323.607C613.285 326.651 609.832 328.091 606.787 326.783C579.937 315.245 462.216 264.66 447.995 258.549C434.332 252.678 465.936 205.532 475.694 191.563Z",
    fill: "#09DE1F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M426.956 210.841C439.074 206.027 462.583 218.132 462.583 218.132L445.134 258.739L405.751 241.816C405.751 241.816 414.838 215.656 426.956 210.841Z",
    fill: "#09DE1F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 407.132,
    y: 238.151,
    width: 224.347,
    height: 3.91303,
    transform: "rotate(23.2535 407.132 238.151)",
    fill: "#414141"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 501.515,
    y: 223.341,
    width: 23.4782,
    height: 44.3477,
    transform: "rotate(23.2535 501.515 223.341)",
    fill: "#414141"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 472.753,
    y: 210.982,
    width: 23.4782,
    height: 24.7825,
    transform: "rotate(23.2535 472.753 210.982)",
    fill: "#414141"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 482.808,
    y: 263.571,
    width: 23.4782,
    height: 3.91303,
    transform: "rotate(23.2535 482.808 263.571)",
    fill: "#4B4848"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 480.58,
    y: 265.453,
    width: 23.4782,
    height: 3.91303,
    transform: "rotate(23.2535 480.58 265.453)",
    fill: "#4B4848"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 535.07,
    y: 237.76,
    width: 23.4782,
    height: 27.3912,
    transform: "rotate(23.2535 535.07 237.76)",
    fill: "#414141"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 568.069,
    y: 250.741,
    width: 23.4782,
    height: 27.3912,
    transform: "rotate(23.2535 568.069 250.741)",
    fill: "#414141"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 599.783,
    y: 265.567,
    width: 23.4782,
    height: 27.3912,
    transform: "rotate(23.2535 599.783 265.567)",
    fill: "#414141"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 614.463,
    y: 317.305,
    width: 2.60869,
    height: 11.7391,
    transform: "rotate(23.2535 614.463 317.305)",
    fill: "#414141"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M538.756 262.218L545.506 260.7",
    stroke: "#9B9B9B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M570.598 277.321L577.348 275.802",
    stroke: "#9B9B9B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M600.558 290.194L607.308 288.676",
    stroke: "#9B9B9B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M535.686 249.542L542.436 248.024",
    stroke: "#9B9B9B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M568.043 263.445L574.793 261.927",
    stroke: "#9B9B9B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M600.399 277.349L607.149 275.831",
    stroke: "#9B9B9B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 454.894,
    cy: 260.804,
    r: 17.6086,
    transform: "rotate(23.2535 454.894 260.804)",
    fill: "#030303"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 454.895,
    cy: 260.804,
    r: 8.99997,
    transform: "rotate(23.2535 454.895 260.804)",
    fill: "#BEBEBE"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 582.606,
    cy: 317.102,
    r: 17.6086,
    transform: "rotate(23.2535 582.606 317.102)",
    fill: "#030303"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 582.607,
    cy: 317.103,
    r: 8.99997,
    transform: "rotate(23.2535 582.607 317.103)",
    fill: "#BEBEBE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M191.446 372.236C268.097 365.674 346.872 372.236 424.03 372.236C457.124 372.236 491.895 374.581 523.939 374.581",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M123.055 405.341C236.416 405.341 349.878 403.22 462.913 411.407",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M276.674 385.102H579.706",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M523.939 372.476C558.865 368.39 595.912 366.163 631.263 366.163",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M481.851 421.671C545.897 421.671 609.97 422.347 674.012 421.51C678.434 421.452 694.193 421.478 701.329 420.222C703.453 419.848 697.135 419.091 695.005 418.772",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M176.716 390.363H357.693",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0797 377.66C105.59 377.66 148.101 377.66 190.612 377.66C200.729 377.66 218.164 374.384 227.222 379.841",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M135.681 452.442C210.723 448.948 285.721 448.234 360.85 448.234",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0709 405.094C234.629 407.171 386.014 409.303 537.618 409.303",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9749 440.869H438.712",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M130.42 390.363C267.905 391.46 405.377 391.415 542.879 391.415",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M176.716 401.937C256.522 407.533 336.517 410.958 416.51 411.758C456.981 412.162 497.294 412.952 537.618 416.668",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M274.57 452.443H462.912",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M106.22 399.833C188.527 412.165 271.324 413.512 354.537 413.512",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9061 350.38C128.691 350.596 157.408 352.484 186.186 352.484",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M55.714 424.034C123.536 429.907 191.4 427.121 258.787 437.712",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7495 504H330.336",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M477.643 446.13H664.933",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M554.453 413.512C575.99 413.259 596.584 411.243 617.585 407.198",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M390.311 192.551H457.651",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M365.059 135.733H453.443",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M147.255 300.927H193.551",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M119.898 269.361H164.09",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M371.496 94.2969C360.306 76.3495 376.688 51.8623 385.483 45.9974C461.556 -4.73322 530.28 55.235 544.355 84.0036C572.857 79.7807 577.871 100.367 576.288 122.01C575.021 139.324 454.187 145.94 393.928 147.083C366.27 149.195 354.655 135.867 352.104 128.037C352.115 128.022 352.126 128.008 352.137 127.995C351.362 126.606 350.354 124.666 349.063 122.01C339.973 103.304 366.305 95.1767 371.496 94.2969Z",
    fill: "#00A3FF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M385.483 45.9974C376.688 51.8623 360.306 76.3495 371.496 94.2969C366.305 95.1767 339.973 103.304 349.063 122.01C357.605 139.585 353.754 125.837 352.104 128.037C354.655 135.867 366.27 149.195 393.928 147.083C454.187 145.94 575.021 139.324 576.288 122.01C577.871 100.367 572.857 79.7807 544.355 84.0036C530.28 55.235 461.556 -4.73322 385.483 45.9974Z",
    stroke: "#00A3FF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M24.99 217.864C13.9543 200.073 30.111 175.799 38.7846 169.985C113.811 119.695 181.589 179.142 195.471 207.661C223.58 203.474 228.526 223.882 226.964 245.336C225.715 262.5 106.543 269.058 47.1134 270.192C19.8365 272.285 8.38096 259.073 5.86497 251.311C5.87585 251.296 5.88683 251.282 5.8979 251.269C5.13344 249.893 4.13954 247.969 2.86654 245.336C-6.09908 226.794 19.8712 218.737 24.99 217.864Z",
    fill: "#00A3FF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7846 169.985C30.111 175.799 13.9543 200.073 24.99 217.864C19.8712 218.737 -6.09909 226.794 2.86654 245.336C11.2903 262.758 7.49255 249.13 5.86497 251.311C8.38096 259.073 19.8365 272.285 47.1134 270.192C106.543 269.058 225.715 262.5 226.964 245.336C228.526 223.882 223.58 203.474 195.471 207.661C181.589 179.142 113.811 119.695 38.7846 169.985Z",
    stroke: "#00A3FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.8564e6d8adb7dbc3bca5d1a3a9ff1517.svg";
export { ForwardRef as ReactComponent };